import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import toast from 'react-hot-toast';
import { detect } from "detect-browser";
import {internalApi, OtherApi} from '../../common/axios';
import { AuthContext } from '../contexts/authContext';

const browser = detect();

const getMySystemInfo = async () => {
    const systemInfo = {
        browser,
        IPv4: null
    };

    const res = await OtherApi.get("https://api.ipify.org/?format=json");
    if (res.status === 200) {
        systemInfo.IPv4 = res.data.ip;
    }
    return systemInfo;
};

const loginRequest = async (credentials) => {
    credentials.systemInfo = await getMySystemInfo();
    const { data } = await internalApi.post("auth/login", credentials);
    return data;
};

export const useLogin = () => {
    const { setCurrentUser } = useContext(AuthContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: loginRequest,
        onSuccess: (user) => {
            setCurrentUser(user);
            queryClient.invalidateQueries({ queryKey: [user.id] });
            toast.success('로그인 되었습니다.');
        },
        onError: (error) => {
            toast.error(error.response.data.message);
        }
    });
};

const deleteAllCookies = () => {
    const cookies = document.cookie.split(";");
    cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie =
            name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });
};


const logoutRequest = async () => {
    return internalApi.get("auth/logout");
};

export const useLogout = () => {
    const { setCurrentUser } = useContext(AuthContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: logoutRequest,
        onSuccess: () => {
            setCurrentUser(null);
            deleteAllCookies();
            queryClient.clear();
            toast.success('로그아웃 되었습니다.');
        }
    });
};

export const registerRequest = async (credentials) => {
    credentials.systemInfo = await getMySystemInfo();
    const response = await internalApi.post("auth/register", credentials);
    return response.status === 200;
}